import { Box, Button, MenuItem, Select, InputLabel, TextField } from '@mui/material';
import { useState } from 'react';

interface Props {
  onAddField: (field: { type: string; label: string }) => void;
  showFieldTypeSelector?: boolean;
}

const DefaultForm = ({ onAddField, showFieldTypeSelector }: Props) => {
  const [inputType, setInputType] = useState('UNDEFINED');
  const [label, setLabel] = useState('');

  const handleAdd = () => {
    if (!label.trim()) return;

    onAddField({ type: inputType, label });
    setLabel('');
    setInputType('TEXT');
  };

  return (
    <Box display="flex" flexDirection="column" gap={2} p={2} width={300}>
      {showFieldTypeSelector && (
        <Box display="flex" alignItems="center" gap={1}>
          <InputLabel sx={{ minWidth: 80 }}>Field Type:</InputLabel>
          <Select value={inputType ?? ''} onChange={(e) => setInputType(e.target.value)} fullWidth size="small">
            <MenuItem value="" disabled>
              Select Type
            </MenuItem>
            {[
              'TEXT',
              'NUMBER',
              'FILE',
              'PASSWORD',
              'SELECT',
              'CHECKBOX',
              'RADIO',
              'CAMERA',
              'FORM',
              'CHECKLIST',
              'DATE',
              'ESIGN',
              // 'TEXTARRAY',
              'SWITCH'
            ].map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </Box>
      )}

      <Box display="flex" alignItems="center" gap={1}>
        <InputLabel sx={{ minWidth: 80 }}>Label:</InputLabel>
        <TextField value={label} onChange={(e) => setLabel(e.target.value)} fullWidth size="small" />
      </Box>
      <Button variant="contained" onClick={handleAdd} disabled={!label.trim()}>
        Add Field
      </Button>
    </Box>
  );
};

export default DefaultForm;
